import React, { Component } from 'react'

export default class ProjectStatus extends Component{
	render(){
		let { props } = this
		return(
			(!props.projectStatus)?
			<div></div>
			:
			<div
				style={{
					marginLeft: "10px"
				}}
			>
				{(props.projectStatus == 'Open')?
						<i className="material-icons" style={{color: "grey"}}>check_box_outline_blank</i>
					:
						(props.projectStatus == 'Pending')?
								<i className="material-icons" >check_box_outline_blank</i>
							:
								<i className="material-icons" style={{color: "rgb(62, 208, 176)"}}>check_box</i>
				}
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/routes/manager/projects/Status.js